import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  border-radius: 24px 24px 0 0;
  position: sticky;
  top: 0;
  z-index: 10;
  
  h3 {
    margin: 0;
    color: white;
    font-size: 18px;
    font-weight: 700;
  }
  
  p {
    margin: 8px 0 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
  }
  
  .total-preview {
    margin-top: 12px;
    padding: 10px 14px;
    background: rgba(16, 185, 129, 0.2);
    border-radius: 10px;
    color: #34d399;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 16px 8px;
  overflow: visible;
`;

export const QuickButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

export const QuickButton = styled.button`
  padding: 10px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    border-color: #3b82f6;
    color: #3b82f6;
    background: #eff6ff;
  }
  
  &.active {
    border-color: #3b82f6;
    background: #3b82f6;
    color: white;
  }
`;

export const OdontogramaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  overflow: visible;
`;

export const ArcadaLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 12px;
  background: #f1f5f9;
  border-radius: 6px;
`;

export const ArcadaWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  padding: 4px 0;
  
  /* Scrollbar estilizada */
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #94a3b8;
    border-radius: 2px;
  }
`;

export const Arcada = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 2px;
  min-width: min-content;
  margin: 0 auto;
  padding: 0 16px;
`;

export const Divisor = styled.div`
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #334155 50%, transparent 100%);
  margin: 12px 0;
`;

export const QuadrantSeparator = styled.div`
  width: 2px;
  height: 38px;
  background: linear-gradient(180deg, transparent 0%, #64748b 50%, transparent 100%);
  margin: 0 2px;
  flex-shrink: 0;
  align-self: center;
`;

export const ToothBox = styled.div<{ selected: boolean; deciduo?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  cursor: pointer;
  padding: ${props => props.deciduo ? '2px' : '3px'};
  border-radius: 6px;
  transition: all 0.2s;
  flex-shrink: 0;
  min-width: ${props => props.deciduo ? '22px' : '26px'};
  background: ${props => {
    if (props.selected && props.deciduo) return 'linear-gradient(135deg, #f472b6 0%, #ec4899 100%)';
    if (props.selected) return 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
    return 'transparent';
  }};
  
  &:hover {
    background: ${props => {
      if (props.selected && props.deciduo) return 'linear-gradient(135deg, #f472b6 0%, #ec4899 100%)';
      if (props.selected) return 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
      return '#f1f5f9';
    }};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: ${props => props.deciduo ? '14px' : '18px'};
    height: ${props => props.deciduo ? '32px' : '38px'};
    fill: ${props => props.selected ? 'white' : '#475569'};
    transition: all 0.2s;
  }
  
  span {
    font-size: ${props => props.deciduo ? '8px' : '9px'};
    font-weight: ${props => props.selected ? '700' : '600'};
    color: ${props => props.selected ? 'white' : '#64748b'};
  }
`;

export const SelectionCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 12px;
  margin-top: 16px;
  
  span {
    font-size: 14px;
    color: #166534;
    font-weight: 600;
  }
  
  .count {
    background: #16a34a;
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  position: sticky;
  bottom: 0;
  background: white;
  border-radius: 0 0 24px 24px;
`;

export const FooterButton = styled.button<{ variant?: 'primary' | 'secondary' | 'text' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          border: none;
          color: white;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
          
          &:disabled {
            background: #94a3b8;
            box-shadow: none;
          }
          
          &:hover:not(:disabled) {
            box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
          }
        `;
      case 'text':
        return `
          background: transparent;
          border: none;
          color: #64748b;
          
          &:hover {
            background: #f1f5f9;
          }
        `;
      default:
        return `
          background: white;
          border: 2px solid #e2e8f0;
          color: #475569;
          
          &:hover {
            border-color: #3b82f6;
            color: #3b82f6;
          }
        `;
    }
  }}
`;

// Estilos para Dentes Decíduos
export const DeciduosSection = styled.div`
  width: 100%;
  margin-top: 20px;
  border: 2px dashed #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(135deg, #fdf4ff 0%, #fce7f3 100%);
`;

export const DeciduosHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(135deg, #f0abfc 0%, #e879f9 100%);
  cursor: pointer;
  transition: all 0.2s;
  
  span {
    font-size: 14px;
    font-weight: 600;
    color: white;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  svg {
    color: white;
  }
  
  &:hover {
    background: linear-gradient(135deg, #e879f9 0%, #d946ef 100%);
  }
`;

export const DeciduosContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const DeciduosDivisor = styled.div`
  width: 80%;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #f0abfc 50%, transparent 100%);
  margin: 8px 0;
`;

